import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker with auto-update (reload once on new version)
if ("serviceWorker" in navigator) {
  // Capture whether a SW was already controlling the page at script load time.
  // controllerchange fires both on first install AND on updates; we only want
  // to reload on updates (when there was already a controller), otherwise a
  // fresh install after clearing the cache causes an extra reload that shows
  // a blank page while React re-mounts and re-fetches all API data.
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) return; // first install — no need to reload
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  // Nouvelle version prête (installée, cache déjà retéléchargé) : on l'active
  // tout de suite. Uniquement s'il y avait déjà une version aux commandes —
  // sur une toute première installation, rien à remplacer.
  const activateWaiting = (reg) => {
    if (reg.waiting && navigator.serviceWorker.controller) {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  };

  // Chaque déploiement change la version du service worker (voir
  // scripts/stamp-version.js). Le navigateur ne vérifie s'il en existe une
  // nouvelle qu'au chargement d'une page : un visiteur qui garde le site ouvert
  // (onglet de téléphone jamais fermé) ne la verrait jamais. On vérifie donc
  // aussi à chaque retour sur l'onglet, et toutes les 10 minutes.
  const UPDATE_CHECK_MS = 10 * 60 * 1000;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Version installée lors d'une visite précédente mais jamais activée
        // (page fermée entre-temps) : `updatefound` ne se redéclenchera pas.
        activateWaiting(reg);
        reg.update();
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed") activateWaiting(reg);
          });
        });
        const check = () => reg.update().catch(() => {});
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
        window.setInterval(check, UPDATE_CHECK_MS);
      })
      .catch(() => {});
  });
}
